import { ErrorListOutput } from '../../types';
import { PaymentPlan } from './QuoteSchema';

export enum PaymentPlanEnum {
  Monthly = 'MONTHLY',
  Annual = 'ANNUAL'
}

export enum PaymentMethod {
  CreditCard = 'CreditCard',
  Ach = 'Ach'
}

export interface BindPolicyInput {
  applicationId: string;
  communityId: string;
  billingAddressCity: string;
  billingAddressState: string;
  billingAddressStreet: string;
  billingZipCode: string;
  paymentPlan: PaymentPlanEnum;
  paymentMethod: PaymentMethod;
  paymentToken: string;
  cardData?: {
    creditCardNumber: string;
    creditCardExpirationDate: string;
    creditCardType: string;
    creditCardName: string;
  };
  achData?: {
    bankAccountName: string;
    bankAccountNumber: string;
  };
}

export interface BindPolicySuccessResponse {
  bindPolicy: {
    id: string;
    applicationDate: string;
    completedAt: string;
    coverageEnd: string;
    policyAmount: number;
    policyExpirationDate: string;
    policyNumber: string;
    policyStatusCd: string;
    price: number;
    provider: string;
    status: string;
    paymentPlans: PaymentPlan[];
    errors: never;
  };
}

export interface BindPolicyErrorResponse {
  bindPolicy: ErrorListOutput & {
    id: never;
    applicationDate: never;
    completedAt: never;
    coverageEnd: never;
    policyAmount: never;
    policyExpirationDate: never;
    policyNumber: never;
    policyStatusCd: never;
    price: never;
    provider: never;
    status: never;
    paymentPlans: never;
  };
}

export type BindPolicyResponse =
  | BindPolicySuccessResponse
  | BindPolicyErrorResponse;

function getPaymentMethodData(input: BindPolicyInput) {
  if (input.paymentMethod === 'CreditCard') {
    return `cardData: {
      creditCardNumber: "${input.cardData?.creditCardNumber}",
      creditCardExpirationDate: "${input.cardData?.creditCardExpirationDate}",
      creditCardType: "${input.cardData?.creditCardType}",
      creditCardName: "${input.cardData?.creditCardName}"
    }`;
  }

  return `achData: {
    bankAccountName: "${input.achData?.bankAccountName}",
    bankAccountNumber: "${input.achData?.bankAccountNumber}"
  }`;
}

export const BIND_POLICY = (input: BindPolicyInput) => {
  const paymentMethodData = getPaymentMethodData(input);

  return `mutation {
        bindPolicy(
          applicationId: "${input.applicationId}",
          bindPolicyInput: {
            communityId: "${input.communityId}",
            billingAddressCity: "${input.billingAddressCity}",
            billingAddressState: "${input.billingAddressState}",
            billingAddressStreet: "${input.billingAddressStreet}",
            billingZipCode: "${input.billingZipCode}",
            paymentPlan: ${input.paymentPlan},
            paymentMethod: ${input.paymentMethod},
            paymentToken: "${input.paymentToken}",
            ${paymentMethodData}
          }
        ) {
          ... on ApplicationOutput {
            id,
            applicationDate,
            completedAt,
            coverageEnd,
            policyAmount,
            policyExpirationDate,
            policyNumber,
            policyStatusCd,
            price,
            provider,
            status,
            paymentPlans {
              paymentPlanCd,
              installmentPaymentAmount,
              totalPremiumAmt,
              downPaymentAmount,
              installmentFeeAmount,
              installmentAmount
            }
          }
          ... on ErrorListOutput {
            errors: errors {
                type
                message
            }
          }
        }

      }
    `;
};
